// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">

<div class="info">
  <div class="info__column">
    <div class="info__field">
      <span class="info__field-label">Branch name:</span>
      <span class="info__field-value">{{\$ctrl.branch.name}}</span>
    </div>
    <div class="info__field">
      <span class="info__field-label">Branch code:</span>
      <span class="info__field-value">{{\$ctrl.branch.code}}</span>
    </div>
    <div class="info__field">
      <span class="info__field-label">Agent code:</span>
      <span class="info__field-value">{{\$ctrl.agent.code}}</span>
    </div>
    <div class="info__field" ng-if="\$ctrl.agent.brdReportId">
      <span class="info__field-label">BRD Report ID:</span>
      <span class="info__field-value">{{\$ctrl.agent.brdReportId}}</span>
    </div>
  </div>
  <div class="info__column" ng-if="\$ctrl.agent.id">
    <button class="btn btn-warning"
            type="button"
            ng-click="\$ctrl.configureMfa()"
            command-access="ConfigureMfa,UpdateUserMfaStatus">
      MFA configuration
    </button>
  </div>
</div>
<div class="alert"
     ng-if="\$ctrl.hasIncompleteData()">
  Customer's Individual Data or Addresses contain incomplete data. You can edit it by clicking 'Go to customer profile'.
  <button type="button"
          class="btn btn-success"
          ng-click="\$ctrl.goToCustomerProfile()">
    Go to customer profile
  </button>
</div>
<div class="profile-body">
  <div class="tab-menu">
    <ul class="nav-tabs">
      <li class="active"><a data-target="#agent_individual_data" data-toggle="tab">
        <span>Individual Data</span></a>
      </li>
      <li><a data-target="#agent_addresses" data-toggle="tab">
        <span>Addresses</span>
      </a></li>
      <li><a data-target="#agent_documents" data-toggle="tab">
        <span><i ng-if="\$ctrl.documentsForm.\$invalid" class="icon icon-warning-sign"></i>Documents</span>
      </a></li>
      <li><a data-target="#agent_income" data-toggle="tab">
        <span><i ng-if="\$ctrl.incomeForm.\$invalid || \$ctrl.customer.incomeSources.length < 1"
                 class="icon icon-warning-sign"></i>Business information</span>
      </a></li>
      <li><a data-target="#agent_credentials" data-toggle="tab">
        <span><i ng-if="\$ctrl.credentialsForm.\$invalid" class="icon icon-warning-sign"></i>Credentials</span>
      </a></li>
      <li><a data-target="#agent_settlement" data-toggle="tab">
        <span><i ng-if="\$ctrl.settlementForm.\$invalid" class="icon icon-warning-sign"></i>Settlement</span>
      </a></li>
      <li ng-if="\$ctrl.agentId"><a data-target="#agent_devices" data-toggle="tab">
        <span><i ng-if="\$ctrl.devicesForm.\$invalid" class="icon icon-warning-sign"></i>Devices</span>
      </a></li>
      <li ng-if="!\$ctrl.agentId"><a data-target="#new_agent_device" data-toggle="tab">
        <span><i ng-if="\$ctrl.newDeviceForm.\$invalid || \$ctrl.isDeviceEdited" class="icon icon-warning-sign"></i>Devices</span>
      </a></li>
    </ul>
  </div>
  <form name="\$ctrl.mainForm">
    <div class="tab-content user-details">
      <div id="agent_individual_data"
           class="tab-pane active">
        <customer-profile-individual-data
          profile="\$ctrl.customer"
          edit-mode="false"
          ng-form="\$ctrl.individualDataForm"
          module="'agent'">
        </customer-profile-individual-data>
      </div>
      <div id="agent_addresses"
           class="tab-pane">
        <customer-profile-addresses
          addresses="\$ctrl.customer.addresses"
          edit-mode="false"
          ng-form="\$ctrl.addressesForm"
          module="'agent'">
        </customer-profile-addresses>
      </div>
      <div id="agent_documents"
           class="tab-pane">
        <div class="alert">
          It's only possible to modify or add new 'Documents' in this view.
          You can remove existing 'Documents' from Customer's profile.
          <button type="button" class="close" data-dismiss="alert">&times;</button>
        </div>
        <customer-profile-documents
          id-documents="\$ctrl.customer.idDocuments"
          profile="\$ctrl.customer"
          edit-mode="\$ctrl.editMode"
          ng-form="\$ctrl.documentsForm"
          module="'agent'">
        </customer-profile-documents>
      </div>
      <div id="agent_income"
           class="tab-pane">
        <div class="alert">
          It's only possible to modify or add new 'Business Information' in this view.
          You can remove existing 'Business Information' from Customer's profile.
          <button type="button" class="close" data-dismiss="alert">&times;</button>
        </div>
        <customer-profile-income
          profile="\$ctrl.customer"
          edit-mode="\$ctrl.editMode"
          ng-form="\$ctrl.incomeForm"
          module="'agent'">
        </customer-profile-income>
      </div>
      <div id="agent_credentials"
           class="tab-pane">
        <agents-credentials
          agent="\$ctrl.agent"
          ng-form="\$ctrl.credentialsForm"
          forced-password-update="false">
        </agents-credentials>
      </div>
      <div id="agent_settlement"
           class="tab-pane">
        <agents-settlement
          agent="\$ctrl.agent"
          ng-form="\$ctrl.settlementForm">
        </agents-settlement>
      </div>
      <div id="agent_devices"
           class="tab-pane"
           ng-if="\$ctrl.agentId">
        <agents-devices
          agent-id="\$ctrl.agentId"
          branch-id="\$ctrl.branch.id"
          ng-form="\$ctrl.devicesForm">
        </agents-devices>
      </div>
      <div id="new_agent_device"
           class="tab-pane"
           ng-if="!\$ctrl.agentId">
        <new-agent-device
          device="\$ctrl.agent.device"
          ng-form="\$ctrl.newDeviceForm"
          is-device-edited="\$ctrl.isDeviceEdited">
        </new-agent-device>
      </div>

      <div class="buttons"
           ng-if="!\$ctrl.isDeviceEdited">
        <button class="btn btn-warning"
                ng-click="\$ctrl.redirectBack()">
          Cancel
        </button>
        <button type="submit"
                class="btn btn-primary"
                ng-click="\$ctrl.createOrUpdate()"
                command-access="CreateAgent"
                ng-disabled="\$ctrl.mainForm.\$invalid">
          Save
        </button>
      </div>
    </div>
  </form>
</div>
</section>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/agent-banking/details/agents-details.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;